// extracted by mini-css-extract-plugin
export default {"checkbox":"_Checkbox_checkbox__8iYiO","disabled":"_Checkbox_disabled__8eaQ0","labelText":"_Checkbox_labelText__hLlUh"};